export const getVariants = (variant: string): EBC.TVas[] => {
  if (!variant) {
    return [];
  }

  const delimiter = variant.includes('/') ? '/' : ',';

  return variant.split(delimiter) as EBC.TVas[];
};
